import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API_URL = process.env.REACT_APP_BACKEND_URL;

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        toast.error(`Google sign-in failed: ${error}`);
        navigate('/login');
        return;
      }

      if (!code) {
        navigate('/login');
        return;
      }

      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const redirectUri = window.location.origin + '/auth/google';

      try {
        const response = await fetch(`${API_URL}/api/auth/google`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, redirect_uri: redirectUri }),
        });

        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.detail || 'Authentication failed');
        }

        const data = await response.json();
        localStorage.setItem('littlelearners-token', data.access_token);

        if (data.is_new_user) {
          toast.success(`Welcome to Zazu, ${data.user?.name || 'there'}!`);
        } else {
          toast.success(`Welcome back, ${data.user?.name || 'there'}!`);
        }

        window.location.href = '/dashboard';
      } catch (err) {
        console.error('Google auth exchange failed:', err);
        toast.error(err.message || 'Google sign-in failed');
        navigate('/login');
      }
    };

    processAuth();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-emerald-500 mx-auto mb-4" />
        <p className="text-slate-600" data-testid="google-callback-loading">Completing sign in...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
